import React from 'react';
import styled from 'styled-components';
import { useDraggable } from '@dnd-kit/core';
import { Tag, Tooltip } from 'antd';
import { HolderOutlined } from '@ant-design/icons';

const CardWrapper = styled.div`
  background: ${({ theme }) => theme.colors.surface};
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: ${({ theme }) => theme.borderRadius.lg || '8px'};
  padding: ${({ theme }) => theme.spacing.sm || '0.5rem'} ${({ theme }) => theme.spacing.md || '1rem'};
  cursor: grab;
  transition: all ${({ theme }) => theme.transitions.fast || '0.15s ease'};
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.sm || '0.5rem'};
  user-select: none;

  &:hover {
    border-color: ${({ theme }) => theme.colors.accent};
    transform: translateY(-1px);
  }

  ${({ $isDragging }) => $isDragging && `
    opacity: 0.5;
    cursor: grabbing;
  `}
`;

const Info = styled.div`
  flex: 1;
  min-width: 0;
`;

const Title = styled.div`
  font-size: 12px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.text};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const DragHandle = styled.span`
  color: ${({ theme }) => theme.colors.textMuted};
  font-size: 14px;
  flex-shrink: 0;
`;

const DraggableTemplate = ({ template }) => {
  const { attributes, listeners, setNodeRef, isDragging } = useDraggable({
    id: `template-${template.id}`,
    data: { template },
  });

  return (
    <Tooltip
      title={template.description || ''}
      placement="left"
      mouseEnterDelay={0.3}
    >
      <CardWrapper
        ref={setNodeRef}
        $isDragging={isDragging}
        {...listeners}
        {...attributes}
      >
        <DragHandle><HolderOutlined /></DragHandle>
        <Info>
          <Title>{template.service}</Title>
        </Info>
        <Tag style={{ margin: 0, fontSize: 9, background: 'var(--odin-status-active-bg)', color: 'var(--odin-status-active-text)', borderColor: 'var(--odin-status-active-border)' }}>
          {template.icon && <span style={{ marginRight: 4 }}>{template.icon}</span>}
          {template.category || 'General'}
        </Tag>
      </CardWrapper>
    </Tooltip>
  );
};

export default React.memo(DraggableTemplate);
